import * as React from "react";

import { BreedJudgeHierarchyDto } from "../../../../../api";
import { JudgeIcon } from "./JudgeIcon";

export interface IJudgeLabelProps {
  judges?: BreedJudgeHierarchyDto[];
  translations?: string[];
}

export const JudgeLabel: React.FunctionComponent<IJudgeLabelProps> = ({ judges, translations }) => {
  const lbl = React.useCallback(() => {
    let label;
    if (translations?.length > 0) {
      label = translations.map((tl, idx) => {
        return (
          <span key={idx}>
            {idx ? " | " : ""}
            {tl}
          </span>
        );
      });
    } else {
    }
    return <JudgeIcon judges={judges} label={label} />;
  }, [judges, translations]);

  return lbl();
};
